import { render } from "./Collection.vue?vue&type=template&id=0d00b422&scoped=true"
import script from "./Collection.vue?vue&type=script&lang=js"
export * from "./Collection.vue?vue&type=script&lang=js"

import "./Collection.vue?vue&type=style&index=0&id=0d00b422&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d00b422"]])

export default __exports__